
    import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
    import { mapActions, mapState } from 'vuex';
    import EingetragenAmVom from '@/components/EingetragenAmVom.vue';
    import Impfempfehlung from '@/types/Impfempfehlung';
    import { confirmSwal } from '@/helper/swals';
    import { SweetAlertResult } from 'sweetalert2';
    import { VForm } from '@/types/Components';
    import {
        DeleteImpfempfehlungPayload,
        ImpfempfehlungFilter,
        UpdateImpfempfehlungPayload,
    } from '@/store/impfempfehlungen';

    @Component({
        components: {
            EingetragenAmVom,
        },
        computed: {
            ...mapState('globals', ['rules']),
            ...mapState('impfempfehlungen', ['loaders']),
        },
        methods: {
            ...mapActions('impfempfehlungen', ['updateImpfempfehlung', 'deleteImpfempfehlung']),
        },
    })
    export default class ImpfempfehlungenDetail extends Vue {
        @Prop() impfempfehlung!: Impfempfehlung;
        @Prop() filter!: ImpfempfehlungFilter;
        @Prop() visible!: boolean;

        public $refs!: {
            form: VForm;
        };

        public updateImpfempfehlung!: (payload: UpdateImpfempfehlungPayload) => void;
        public deleteImpfempfehlung!: (payload: DeleteImpfempfehlungPayload) => void;

        public get isEdit(): boolean {
            return this.impfempfehlung.impfempfehlung_id !== null;
        }

        @Watch('visible')
        public onChangeVisible(visible: boolean): void {
            if (visible) {
                if (this.$refs.form) {
                    this.$refs.form.resetValidation();
                }
            }
        }

        public onClickSave(): void {
            if (this.$refs.form.validate()) {
                this.updateImpfempfehlung({ impfempfehlung: this.impfempfehlung, filter: this.filter });
            }
        }

        public onClickDelete(): void {
            confirmSwal('Löschen', 'Impfempfehlung endgültig löschen?', 'Löschen', 'Abbrechen')
                .then(({ isConfirmed }: SweetAlertResult) => {
                    if (isConfirmed) {
                        this.deleteImpfempfehlung({ impfempfehlung: this.impfempfehlung, filter: this.filter });
                    }
                });
        }
    }
